/* eslint-disable */
import { observable, action, transaction } from 'mobx'
import moment from 'moment'
import validator from 'validator'
import axios from 'axios'

import Auth from './Auth'

import config from '../config'

class Payment {
  @observable mass = []

  @observable revenue = {}
  @observable transactions = {}
  @observable methods = {}

  @action
  getMassPayment = pId => {
    return axios({
      method: 'get',
      url: `${config.api_uri}/payment/payment/${pId}`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      }
    })
      .then(res => {
        const index = this.mass.slice().findIndex(p => p.id === pId)
        this.mass.replace([
          ...(index > -1
            ? [
                ...this.mass.slice(0, index),
                res.data.data,
                ...this.mass.slice(index + 1)
              ]
            : [...this.mass.slice(), res.data.data])
        ])

        return res.data.data
      })
      .catch(e => {
        console.warn(e)
      })
  }

  @action
  getAllMassPayments = date => {
    const sDate = moment(date)
      .subtract(10, 'years')
      .startOf('month')
      .format('YYYY-MM-DD')

    const eDate = moment(date)
      .endOf('month')
      .format('YYYY-MM-DD')
    const range = `${sDate}|${eDate}`

    return axios({
      method: 'get',
      url: `${config.api_uri}/payment/payment/?date_range=${range}`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      }
    })
      .then(res => {
        this.mass.replace([...res.data.data])

        return res.data.data
      })
      .catch(e => {
        console.warn(e)
      })
  }

  @action
  reloadMassPayment = pId => {
    const paymentIndex = this.mass.slice().findIndex(p => p.id === pId)

    if (!this.mass[paymentIndex]) {
      return Promise.resolve()
    }

    return axios({
      method: 'post',
      url: `${config.api_uri}/payment/payment/rebuild?date=${this.mass[
        paymentIndex
      ].date.slice(0, 7)}`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      }
    })
      .then(res => {
        this.mass.replace([
          ...(paymentIndex > -1
            ? [
                ...this.mass.slice(0, paymentIndex),
                ...this.mass.slice(paymentIndex + 1)
              ]
            : [...this.mass.slice()])
        ])

        return paymentIndex > -1
          ? this.mass.slice()[paymentIndex]
          : this.mass.slice()[this.mass.length - 1]
      })
      .catch(e => {
        console.warn(e)
      })
  }

  @action
  patchMassPayment = (pId, field, value) => {
    return axios({
      method: 'patch',
      url: `${config.api_uri}/payment/payment/${pId}`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      },
      data: {
        op: 'replace',
        path: `/${field}`,
        value
      }
    })
      .then(res => {
        const index = this.mass.slice().findIndex(p => p.id === pId)
        this.mass.replace([
          ...(index > -1
            ? [
                ...this.mass.slice(0, index),
                {
                  ...this.mass.slice()[index],
                  [field]: value
                },
                ...this.mass.slice(index + 1)
              ]
            : [...this.mass.slice(), ...this.getMassPayment(pId)])
        ])

        return index > -1
          ? this.mass.slice()[index]
          : this.mass.slice()[this.mass.length - 1]
      })
      .catch(e => {
        console.warn(e)
      })
  }

  // revenue
  @action
  getRevenueReport = (comId, date) => {
    const sDate = moment(date)
      .subtract('10', 'years')
      .startOf('month')
      .format('YYYY-MM-DD')

    const eDate = moment(date)
      .endOf('month')
      .format('YYYY-MM-DD')
    const range = `${sDate}|${eDate}`

    return axios({
      method: 'get',
      url: `${config.api_uri}/payment/${comId}/revenue?date_range=${range}`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      }
    })
      .then(res => {
        this.revenue = {
          ...this.revenue,
          [comId]: [...res.data.data]
        }

        return res.data.data
      })
      .catch(e => {
        console.warn(e)
      })
  }

  @action
  getBatchRevenueReport = date => {
    let sDate = moment(...(date ? [date] : []))

    if (!date) {
      sDate = sDate.subtract(10, 'years')
    }

    sDate = sDate.startOf('month').format('YYYY-MM-DD')

    const eDate = moment(date)
      .endOf('month')
      .format('YYYY-MM-DD')
    const range = `${sDate}|${eDate}`

    return axios({
      method: 'get',
      url: `${config.api_uri}/payment/*/revenue?date_range=${range}`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      }
    })
      .then(res => {
        this.revenue = {
          ...this.revenue,
          ...res.data.data
        }

        return res.data.data
      })
      .catch(e => {
        console.warn(e)
      })
  }

  @action
  postManualRevenueReport = (comId, data) => {
    return axios({
      method: 'post',
      url: `${config.api_uri}/payment/${comId}/revenue/`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      },
      data: {
        date: data.date,
        total: data.total
      }
    })
      .then(res => {
        const _iDate = new Date(data.date)
        _iDate.setMonth(_iDate.getMonth() + 1)
        const revenueIndex = this.revenue[comId].slice().findIndex(_item => {
          const __iDate = new Date(Date.UTC(..._item.date.split('-')))

          return (
            _iDate.getMonth() === __iDate.getMonth() &&
            _iDate.getFullYear() === __iDate.getFullYear()
          )
        })

        this.revenue = {
          ...this.revenue,
          [comId]: [
            ...(revenueIndex > -1
              ? [
                  ...this.revenue[comId].slice(0, revenueIndex),
                  {
                    ...this.revenue[comId][revenueIndex],
                    total:
                      +this.revenue[comId][revenueIndex].total + +data.total,
                    report: [
                      ...this.revenue[comId][revenueIndex].report,
                      {
                        id: Date.now(),
                        manual: true,
                        amount: +data.total,
                        date: `${_iDate.getUTCFullYear()}-${_iDate.getUTCMonth()}-${_iDate.getUTCDate()}`
                      }
                    ]
                  },
                  ...this.revenue[comId].slice(revenueIndex + 1)
                ]
              : [
                  ...this.revenue[comId],
                  {
                    id: 1,
                    date: `${_iDate.getUTCFullYear()}-${_iDate.getUTCMonth()}-01`,

                    total: +data.total,
                    report: [
                      {
                        id: Date.now(),
                        manual: true,
                        amount: +data.total,
                        date: `${_iDate.getUTCFullYear()}-${_iDate.getUTCMonth()}-${_iDate.getUTCDate()}`
                      }
                    ]
                  }
                ])
          ]
        }

        return this.revenue[comId]
      })
      .catch(e => {
        console.warn(e)
      })
  }

  // transactions
  @action
  getTransactionReport = (comId, date) => {
    const sDate = moment(date)
      .subtract('10', 'years')
      .startOf('month')
      .format('YYYY-MM-DD')

    const eDate = moment(date)
      .endOf('month')
      .format('YYYY-MM-DD')
    const range = `${sDate}|${eDate}`

    return axios({
      method: 'get',
      url: `${config.api_uri}/payment/${comId}/payment?date_range=${range}`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      }
    })
      .then(res => {
        this.transactions = {
          ...this.transactions,
          [comId]: [...res.data.data]
        }

        return res.data.data
      })
      .catch(e => {
        console.warn(e)
      })
  }

  @action
  postTransaction = (comId, data) => {
    return axios({
      method: 'post',
      url: `${config.api_uri}/payment/${comId}/payment/`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      },
      data: {
        date: data.date,
        total: data.amount,
        payee: data.payee,
        type: data.type
      }
    })
      .then(res => {
        this.transactions = {
          ...this.transactions,
          [comId]: [...this.transactions[comId], res.data.data]
        }

        return res.data.data
      })
      .catch(e => {
        console.warn(e)
      })
  }

  @action
  patchTransaction = (comId, pId, field, value) => {
    return axios({
      method: 'patch',
      url: `${config.api_uri}/payment/${comId}/payment/${pId}`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      },
      data: {
        op: 'replace',
        path: `/${field}`,
        value
      }
    })
      .then(res => {
        const index = (this.transactions[comId] || []).find(t => t.id === pId)

        if (index > -1) {
          this.transactions = {
            ...this.transactions,
            [comId]: [
              ...this.transactions[comId].slice(0, index),
              {
                ...this.transactions[comId][index],
                [field]: value
              },
              ...this.transactions[comId].slice(index + 1)
            ]
          }
        } else {
          return this.getTransactionReport(comId)
        }

        return res.data.data
      })
      .catch(e => {
        console.warn(e)
      })
  }

  // method
  @action
  getMethod = comId => {
    return axios({
      method: 'get',
      url: `${config.api_uri}/payment/${comId}/method`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      }
    })
      .then(res => {
        this.methods = {
          ...this.methods,
          [comId]: {
            ...res.data.data
          }
        }

        return res.data.data
      })
      .catch(e => {
        console.warn(e)
      })
  }

  @action
  putMethod = (comId, data) => {
    if (data.type !== 'wire') {
      if (!data.address) {
        // `Missing arguments (address)`
        return Promise.reject()
      }

      if (data.type === 'paypal') {
        if (!validator.isEmail(data.address)) {
          // `Address needs to be an email`
          return Promise.reject()
        }
      }
    }

    const _data = {
      type: data.type,
      ...(data.type !== 'wire' ? { address: data.address } : {})
    }

    return axios({
      method: 'put',
      url: `${config.api_uri}/payment/${comId}/method`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      },
      data: _data
    })
      .then(res => {
        this.methods = {
          ...this.methods,
          [comId]: {
            ...res.data.data
          }
        }

        return res.data.data
      })
      .catch(e => {
        console.warn(e)
      })
  }
}

export default new Payment()



// WEBPACK FOOTER //
// ./src/stores/Payment.js